(function () {
    'use strict';

    function workflowConfigurationDataService($http) {
        var apiBaseUrl = '[BuildifyApiHost]/api/';

        function loadLinkedTemplate(id) {
            return $http.get(apiBaseUrl + id).then(function (response) {
                return response.data;
            });
        };

        function loadHtmlTemplate(id) {
            return $http.get(apiBaseUrl + id).then(function (response) {
                return response.data;
            });
        };

        function getWorkflowConfiguration(id, entityType, entityId) {
            var url = apiBaseUrl;
            if (entityType && entityId) {
                url += entityType + '/' + entityId + '/';
            }

            url += 'workflowconfigurations?t=' + id;
            return $http.get(url).then (function (response) {
                return response.data;
            });
        };

        return {
            loadLinkedTemplate: loadLinkedTemplate,
            loadHtmlTemplate: loadHtmlTemplate,
            getWorkflowConfiguration: getWorkflowConfiguration
        }
    }

    workflowConfigurationDataService.$inject = ['$http'];

    angular.module('ecap.common').service('workflowConfigurationDataService', workflowConfigurationDataService);
})();